import React from 'react';
import styled from 'styled-components';

import Badge from '../shared/Badge';
import EventDropdownButton from '../event/EventDropdownButton';
import ConcatOperatorSelector from './ConcatOperatorSelector';
import EventOthersFilter from './EventOthersFilter';
import EventFilters from './EventFilters';

const FilterContainer = styled.div`
  margin-top: 10px;
  max-width: 370px;

  .header {
    display: flex;
    justify-content: center;
  }

  .button-content {
    display: flex;
    justify-content: center;
  }
`;

const EventFilterContainer = ({
  onCopyFilter,
  onAddFilterClause,
  setFilterVisibility,
  badgeCount,
  clauses,
  concatOperator,
  onSetClausesConcatOperator,
  visibility,
  isEvent,
  btnText = 'Filter',
  ...props
}) => {
  const onDragOver = (e) => e.preventDefault();
  const onDrop = (e) => onCopyFilter(JSON.parse(e.dataTransfer.getData('clauses')));

  const onClickHandler = () => (!clauses.length ? onAddFilterClause() : setFilterVisibility());

  const onDragStart = (e) => e.dataTransfer.setData('clauses', JSON.stringify(clauses));

  const isShowEventOthersFilter = clauses.length > 0 && visibility && isEvent;

  return (
    <FilterContainer onDragOver={onDragOver} onDrop={onDrop}>
      <div className="header">
        <EventDropdownButton onClick={onClickHandler}>
          <div className="button-content" onDragStart={onDragStart} draggable>
            {!!badgeCount && <Badge count={badgeCount} style={{ marginRight: 5 }} />}
            <div>{btnText}</div>
          </div>
        </EventDropdownButton>
        {/* <Button className="square-icon-button" onClick={onRemoveFilter} style={{border: "1px solid transparent"}}> */}
        {/*  <Icon type="delete"/> */}
        {/* </Button> */}
        <ConcatOperatorSelector
          value={concatOperator}
          onSelect={onSetClausesConcatOperator}
          style={{ marginRight: 0 }}
        />
      </div>
      <EventFilters
        visibility={visibility}
        clauses={clauses}
        onAddFilterClause={onAddFilterClause}
        {...props}
      />
      {isShowEventOthersFilter && <EventOthersFilter clauses={clauses} {...props} />}
    </FilterContainer>
  );
};

export default EventFilterContainer;
